import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledModalRedirectContainer = styled.div<any>`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding: 30px 10px;
`;

export const StyledTitleWithLogo = styled.div<any>`
  ${({hasDescription}) => `
    margin-bottom: ${hasDescription ? '15px' : '100px'};
    @media (min-width: 767px) {
      margin-bottom: ${hasDescription ? '23px' : '100px'};
    }
  `}

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 23px;
  height: max-content;

  @media (min-width: 767px) {
    flex-direction: row;
    gap: 15px;
  }
`;

export const StyledModalRedirectTitle = styled.div<any>`
  font-family: 'vw-head';
  font-style: normal;
  font-weight: 700;
  padding: 0 5%;
  h2 {
    margin: 0;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    padding: 0;
  }
`;

export const StyledModalRedirectDescription = styled.div`
  margin-bottom: 40px;

  @media (min-width: ${Breakpoints.b1280}px) {
    margin: 0 60px 40px 60px;
  }
`;
export const StyledModalRedirectImage = styled.div`
  width: max-content;
  height: max-content;
  img {
    width: 42px;
    height: 40px;
  }
`;

export const StyledModalRedirectButton = styled.div`
  width: auto;
`;
